import React from "react";
import PropTypes from "prop-types";
import Store from "./store";

import headerApiUrlsFallback from "./utils/headerApiUrlsFallback";

import AppErrorHandler from "./components/AppErrorHandler";
import Header from "./Header";

import getEnvironDomain from "./utils/getEnvironDomain";

import { StoreProvider } from "./connect";

/* eslint-disable no-undef */
if (HEADER_BUNDLE_VERSION) {
  window.HEADER_BUNDLE_VERSION = HEADER_BUNDLE_VERSION;
}
/* eslint-enable no-undef */
class App extends React.Component {
  baseUrl;

  constructor(props) {
    super(props);

    const profileUrl = headerApiUrlsFallback(props.profileUrl, "profile");
    const notificationUrl = headerApiUrlsFallback(
      props.notificationsUrl,
      "notifications"
    );

    this.baseUrl = props.baseUrl || getEnvironDomain();

    this.store = new Store(
      this.baseUrl,
      profileUrl,
      notificationUrl,
      props.getWsTokenUrl,
      props.webSocketUrl,
      props.chatUrl
    );
  }

  handleUserLogin = () => {
    if (this.props.onUserLogin) {
      this.props.onUserLogin();
    }
    this.store.profile.loadProfile({});
  };

  restorePasswordRedirect = () => {
    window.location = `https://${this.baseUrl}/SendPassword.aspx`;
  };

  render() {
    return (
      <AppErrorHandler slot="all">
        <StoreProvider value={this.store}>
          <Header
            onUserLogin={this.handleUserLogin}
            onRestorePasswordRedirect={this.restorePasswordRedirect}
          />
        </StoreProvider>
      </AppErrorHandler>
    );
  }
}

App.propTypes = {
  baseUrl: PropTypes.string,
  notificationsUrl: PropTypes.string,
  chatUrl: PropTypes.string,
  profileUrl: PropTypes.string,
  getWsTokenUrl: PropTypes.string,
  webSocketUrl: PropTypes.string,
  onUserLogin: PropTypes.func,
};

export default App;
